var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        [
          _c("el-col", { attrs: { span: 12 } }, [
            _vm.cadastroOriginal.cadastrante.pessoa.pessoaFisica &&
            _vm.cadastroOriginal.cadastrante.pessoa.pessoaFisica.cpf
              ? _c(
                  "div",
                  { key: "pessoaFisica" },
                  [
                    _vm.cadastroOriginal.cadastrante.pessoa.pessoaFisica.cpf
                      ? _c("app-display", {
                          class:
                            _vm.compararCadastranteAreasPatrimoniais &&
                            _vm.compararCadastranteAreasPatrimoniais.mudouPessoa
                              .mudouCPF
                              ? "text"
                              : "",
                          attrs: {
                            label: "CPF:",
                            content:
                              _vm.cadastroOriginal.cadastrante.pessoa
                                .pessoaFisica.cpf
                          }
                        })
                      : _vm._e(),
                    _c("app-display", {
                      class:
                        _vm.compararCadastranteAreasPatrimoniais &&
                        _vm.compararCadastranteAreasPatrimoniais.mudouPessoa
                          .mudouNome
                          ? "text"
                          : "",
                      attrs: {
                        label: "Nome:",
                        content:
                          _vm.cadastroOriginal.cadastrante.pessoa.pessoaFisica
                            .nome
                      }
                    }),
                    _c("app-display", {
                      class:
                        _vm.compararCadastranteAreasPatrimoniais &&
                        _vm.compararCadastranteAreasPatrimoniais.mudouPessoa
                          .mudouMatricula
                          ? "text"
                          : "",
                      attrs: {
                        label: "Matrícula:",
                        content:
                          _vm.cadastroOriginal.cadastrante.pessoa.pessoaFisica
                            .matricula
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.cadastroOriginal.cadastrante.pessoa.pessoaJuridica &&
            _vm.cadastroOriginal.cadastrante.pessoa.pessoaJuridica.cnpj
              ? _c(
                  "div",
                  [
                    _c("app-display", {
                      class:
                        _vm.compararCadastranteAreasPatrimoniais &&
                        _vm.compararCadastranteAreasPatrimoniais.mudouPessoa
                          .mudouCNPJ
                          ? "text"
                          : "",
                      attrs: {
                        label: "CNPJ:",
                        content:
                          _vm.cadastroOriginal.cadastrante.pessoa.pessoaJuridica
                            .cnpj
                      }
                    }),
                    _c("app-display", {
                      class:
                        _vm.compararCadastranteAreasPatrimoniais &&
                        _vm.compararCadastranteAreasPatrimoniais.mudouPessoa
                          .mudouRazaoSocial
                          ? "text"
                          : "",
                      attrs: {
                        label: "Razão Social:",
                        content:
                          _vm.cadastroOriginal.cadastrante.pessoa.pessoaJuridica
                            .razaoSocial || "-"
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ]),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("app-display-multiple", {
                class:
                  _vm.compararCadastranteAreasPatrimoniais &&
                  _vm.compararCadastranteAreasPatrimoniais.mudouPessoa
                    .mudouTelefones
                    ? "text"
                    : "",
                attrs: {
                  label: "Telefone(s):",
                  content: _vm.cadastroOriginal.cadastrante.pessoa.telefones
                }
              }),
              _c("app-display", {
                class:
                  _vm.compararCadastranteAreasPatrimoniais &&
                  _vm.compararCadastranteAreasPatrimoniais.mudouPessoa
                    .mudouEmail
                    ? "text"
                    : "",
                attrs: {
                  label: "E-mail:",
                  content: _vm.cadastroOriginal.cadastrante.pessoa.email
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            [
              _c(
                "app-collapse",
                { attrs: { title: "Solicitação" } },
                [
                  _c("p", {
                    staticClass: "conteudo",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.cadastroOriginal.cadastrante.solicitacao
                      )
                    }
                  }),
                  _c("listagem-documentos", {
                    attrs: {
                      documentos: [_vm.cadastroOriginal.cadastrante.oficio],
                      protocoloCadastroOriginal: _vm.cadastroOriginal.protocolo,
                      ownerDocumento: "OFICIO",
                      compararDocumentos:
                        _vm.compararCadastranteAreasPatrimoniais &&
                        _vm.compararCadastranteAreasPatrimoniais
                          .mudouDocumentosCadastrante,
                      versaoCadastro: _vm.versaoCadastro
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            [
              _c(
                "app-collapse",
                { attrs: { title: "Endereço" } },
                [
                  _c("informacoes-endereco", {
                    attrs: {
                      slot: "body",
                      endereco: _vm.enderecoCadastrante,
                      mudouEndereco:
                        _vm.compararCadastranteAreasPatrimoniais &&
                        _vm.compararCadastranteAreasPatrimoniais.mudouEndereco
                    },
                    slot: "body"
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-107ea386", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-107ea386","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/informacoesCadastro/cadastrosOnline/areasPatrimoniais/InformacoesCadastranteAreasPatrimoniais.vue
// module id = null
// module chunks = 